import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PageMenu from '../../../blocks/PageMenu/PageMenu';
import IconArrowGray from "../../../../img/icons/svg/botones/flecha-big-gris.svg";

import useGetReanudacionCATAByID from "services/record/ReanudacionCATA/useGetReanudacionCATAByID";
import useGetInfoReanudacionCATA from "services/record/ReanudacionCATA/useGetInfoReanudacionCATA";
import useGetReanudacionCATAByUser from "services/record/ReanudacionCATA/useGetReanudacionCATAByUser";

import useDecode from "hooks/useDecode";

import ManagementFormCardList from 'components/blocks/ManagementNewForms/CardList/ManagementFormCardList';

import Loader from "components/blocks/Loader/Loader";
import ErrorDisplay from "components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla";
import ReanudacionCATA from "./ReanudacionCATA";

const GridReanudacionCATA = ({ expedienteId = null, origen = null }) => {

    const {
        getReanudacionCATAByID,
        loadingGetReanudacionCATAByID,
        statusGetReanudacionCATAByID
    } = useGetReanudacionCATAByID();

    const {
        getInfoReanudacionCATA,
        loadingGetInfoReanudacionCATA,
        statusGetInfoReanudacionCATA
    } = useGetInfoReanudacionCATA();

    const {
        dataGetReanudacionCATAByUser,
        getReanudacionCATAByUser,
        loadingGetReanudacionCATAByUser,
        statusGetReanudacionCATAByUser
    } = useGetReanudacionCATAByUser();

    const [currentHttp, setCurrentHttp] = useState({
        status: null,
        statusText: null
    });

    const title = "Solicitud de reanudación de la prestación de cese de actividad";
    const navigate = useNavigate();

    const tokenResponse = useDecode("token");
    const userId = tokenResponse?.extension_id;
    
    const expedienteIdByOrigen = Number(origen) === 1 ? (expedienteId ?? null) : null;
    const dataUserWithExpedienteByOrigen = (data) => (expedienteIdByOrigen !== null && expedienteIdByOrigen !== undefined ? { ...data, ExpedienteId: expedienteIdByOrigen } : data);

    const [dataUser, setDataUser] = useState<any>(null);
    const [info, setInfo] = useState(false);
    const [showGenerateButton, setShowGenerateButton] = useState(true);
    const [formRenderKey, setFormRenderKey] = useState(0);
    const [generateKey, setGenerateKey] = useState(0);
    const activeRequestRef = useRef(0);
    useEffect(() => {
        getReanudacionCATAByUser(userId, expedienteIdByOrigen);
    }, []);

    useEffect(() => {
        if (statusGetReanudacionCATAByID?.status) {
            setCurrentHttp({
                status: statusGetReanudacionCATAByID.status,
                statusText: statusGetReanudacionCATAByID.statusText
            });
        } else if (statusGetInfoReanudacionCATA?.status) {
            setCurrentHttp({
                status: statusGetInfoReanudacionCATA.status,
                statusText: statusGetInfoReanudacionCATA.statusText
            });
        } else if (statusGetReanudacionCATAByUser?.status) {
            setCurrentHttp({
                status: statusGetReanudacionCATAByUser.status,
                statusText: statusGetReanudacionCATAByUser.statusText
            });
        }
    }, [
        statusGetReanudacionCATAByID,
        statusGetInfoReanudacionCATA,
        statusGetReanudacionCATAByUser
    ]);

    const rowSelected = (args: any) => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setDataUser(null);
        setInfo(false);
        getReanudacionCATAByID(
            args.data.UsuarioId,
            args.data.PrestacionId,
            args.data.Id,
            (data) => {
                if (activeRequestRef.current === requestId) {
                    setDataUser(dataUserWithExpedienteByOrigen(data));
                }
            }
        );
    };

    const handleInfo = async () => {
        const requestId = Date.now();
        activeRequestRef.current = requestId;
        setFormRenderKey(prev => prev + 1);
        setGenerateKey(prev => prev + 1);
        setDataUser(null);
        setInfo(true);
        await getInfoReanudacionCATA(userId, (data) => {
            if (activeRequestRef.current === requestId) {
                setDataUser(dataUserWithExpedienteByOrigen(data));
            }
        });
    };

    useEffect(() => {
        const arrData = dataGetReanudacionCATAByUser;

        if (arrData && Array.isArray(arrData)) {
            const hasFormZero = arrData.some(item => item.EstadoFormulario === 1 || item.EstadoFormulario === 3);
            setShowGenerateButton(!hasFormZero);
        }
    }, [dataGetReanudacionCATAByUser]);

    const isLoading = () => {
        return (
            loadingGetReanudacionCATAByID ||
            loadingGetInfoReanudacionCATA ||
            (loadingGetReanudacionCATAByUser && !dataUser)
        );
    };

    return (
        <div className="container bg-#EEEEEE management-new-forms-typography">
            <PageMenu title={title}>
                <div className="btns-header-container">
                    <button aria-label="Volver atrás" onClick={() => navigate(-1)}>
                        <img src={IconArrowGray} alt="" />
                    </button>
                </div>
            </PageMenu>

            <div className="container">
                <ManagementFormCardList dataSource={dataGetReanudacionCATAByUser || []} onSelect={rowSelected} key={generateKey} />
            </div>

            {showGenerateButton && (
                <div className="container">
                    <div className="delta-buttons c-right">
                    <button className="btn-box btn-accent" onClick={handleInfo}>
                        Generar Formulario
                    </button>
                    </div>
                </div>
            )}

            <Loader activeLoader={isLoading()} label="Cargando Formulario" />

            {dataUser && currentHttp.status === 200 && (
                <div className="mt-5">
                    <ReanudacionCATA
                        key={`${info ? "create" : "edit"}-${dataUser?.Id ?? "new"}-${formRenderKey}`}
                        dataUser={dataUser}
                        info={info}
                        onSuccess={() => getReanudacionCATAByUser(userId, expedienteIdByOrigen)}
                    />
                </div>
            )}

            {currentHttp.status && currentHttp.status !== 200 && (
                <ErrorDisplay descripcionError={currentHttp.statusText} />
            )}
        </div>
    );
};

export default GridReanudacionCATA;


